export enum TriggerbeeApi {
  Gateway,
}
